import { render, staticRenderFns } from "./TipRate.vue?vue&type=template&id=23f3551b&scoped=true"
import script from "./TipRate.vue?vue&type=script&lang=js"
export * from "./TipRate.vue?vue&type=script&lang=js"
import style0 from "./TipRate.vue?vue&type=style&index=0&id=23f3551b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3551b",
  null
  
)

export default component.exports